module.exports = __webpack_public_path__ + "img/fee-left.b5fb9b2c.png";